import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";

@Component({
  selector: 'app-payment-method-edit-dialog',
  templateUrl: './payment-method-edit-dialog.component.html',
  styleUrls: ['./payment-method-edit-dialog.component.css']
})
export class PaymentMethodEditDialogComponent implements OnInit {
  id = null;
  oldName = null;
  paymentMethod = new FormGroup({
    name: new FormControl()
  });

  constructor(public dialogRef: MatDialogRef<PaymentMethodEditDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    if (data.method) {
      this.id = data.method.id;
      this.paymentMethod.patchValue(data.method);
      this.oldName = data.method.name;
    }
  }

  ngOnInit() {
  }

  public closeDialog(): void {
    this.dialogRef.close();
  }

  public submitDialog(remove): void {
    if (remove) {
      const result = this.paymentMethod.value;
      if (this.id) {
        result.id = this.id;
      }
      result.deleted = true;
      this.dialogRef.close(result);
    } else {
      const result = this.paymentMethod.value;
      if (this.id) {
        result.id = this.id;
      }
      this.dialogRef.close(result);
    }
  }

  isValid() {
    return this.paymentMethod.get('name').value;
  }

 
}